import { Log, Level, Logger } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import {
    ISetEnrollment, IEnrollmentData, ISetEnrollmentStateAction
} from '../../models/action/enrollment';
import * as Actions from '../constants/all';
import { IUpdateAssignmentUploadCount } from '../../models/action/assignment';

const _logger = Log.create('Enrollemnt Reducer');

const setRefreshMyEnrollmentsFunc = (pageData: any, enrollmentData: IEnrollmentData[] , newState: any) => {
    if (pageData.enrollmentData && pageData.enrollmentData.length > 0) {

        if (enrollmentData && enrollmentData.length > 0) {
            // update existing ones
            enrollmentData = enrollmentData.map(element => {
                let newElement = pageData.enrollmentData.find((x: IEnrollmentData) => x.activityId === element.activityId);
                if (newElement) {
                    return newElement;
                } else {
                    return element;
                }
            });

            // add those that are not
            pageData.enrollmentData.forEach((element: IEnrollmentData) => {
                let index = enrollmentData.findIndex(x => x.enrollmentId === element.enrollmentId)

                if (index === -1) {
                    enrollmentData.push(element);
                }

            });

            newState.enrollmentData = enrollmentData;

        }
        else {
            newState.enrollmentData = pageData.enrollmentData;
        }
    }
}

const enrollmentSetStateFunc = (pageData: any, enrolldata: IEnrollmentData[] , newState: any ) => {
    if (pageData.enrollData.length > 0) {
        const currentEnrollData = enrolldata.find(x => x.enrollmentId === pageData.enrollData[0].enrollmentId);
        if (pageData.enrollData) {
            if (currentEnrollData) {
                enrolldata.splice(enrolldata.findIndex(x => x.enrollmentId === pageData.enrollData[0].enrollmentId), 1, pageData.enrollData[0]);
            } else {
                enrolldata.push(pageData.enrollData[0]);
            }
        }
    }

    newState.enrollmentData = [...enrolldata];
}

export const enrollmentReducer = (state = GlobalState().enrollment, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    let newState: any = {};
    if (action.type === Actions.enrollmentActions.ENROLLMENT_SETDATA) {

        newState = { enrollmentData: { ...state.enrollmentData } };
        const pageData = (action as ISetEnrollment);

        newState.enrollmentData = pageData.enrollmentData ?? [];

    } else if (action.type === Actions.enrollmentActions.ENROLLMENT_SETSTATE) {

        const enrolldata: IEnrollmentData[] = state.enrollmentData;
        const pageData = (action as ISetEnrollmentStateAction);

        enrollmentSetStateFunc(pageData, enrolldata, newState);
    } else if (action.type === Actions.assigment.UPDATE_ASSIGNMENT_UPLOADEDCOUNT) {

        const enrolldata: IEnrollmentData[] = state.enrollmentData;
        const pageData = (action as IUpdateAssignmentUploadCount);

        const assignmentData: IEnrollmentData = enrolldata.find(s => s.enrollmentId === pageData.enrollmentId)!;
        assignmentData.uploadCount = pageData.uploadCount + 1;
        enrolldata.splice(enrolldata.findIndex(x => x.enrollmentId === pageData.enrollmentId), 1, assignmentData);

        newState.enrollmentData = [...enrolldata];
    }
    else if (action.type === Actions.enrollmentActions.SET_REFRESH_MY_ENROLLMENTS) {
        const enrollmentData: IEnrollmentData[] = state.enrollmentData;
    
        const pageData = (action as ISetEnrollment);
        
        setRefreshMyEnrollmentsFunc(pageData, enrollmentData, newState);

    }
    else {
        return state;
    }
    return Object.assign({}, state, newState);
};
export default enrollmentReducer;
